/** Skeleton leve para Suspense de rotas lazy (já dentro de `.bp-page`). */
export function HubPageSkeleton() {
  return (
    <div aria-busy="true" aria-live="polite">
      <span className="bp-sr-only">Carregando página…</span>
      <div className="bp-skel-header">
        <div className="bp-skel bp-skel--line bp-skel--w40" />
        <div className="bp-skel bp-skel--line bp-skel--title" />
      </div>
      <div className="bp-card bp-skel-card">
        <div className="bp-skel bp-skel--line bp-skel--w50" />
        <div className="bp-skel bp-skel--block bp-skel--block-sm" />
        <div className="bp-skel bp-skel--line bp-skel--w70" />
      </div>
    </div>
  )
}
